(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vb-faq-section')) {
    customElements.define(
      'vb-faq-section',
      class VbFaqSection extends HTMLElement {
        connectedCallback() {
          this.searchInput = this.querySelector('[data-faq-search]');
          this.noResults = this.querySelector('[data-faq-no-results]');
          this.navItems = this.querySelectorAll('[data-faq-nav-item]');

          if (this.searchInput) {
            this.onSearch = this.handleSearch.bind(this);
            this.searchInput.addEventListener('input', this.onSearch);
          }
        }

        disconnectedCallback() {
          if (this.searchInput && this.onSearch) {
            this.searchInput.removeEventListener('input', this.onSearch);
          }
        }

        handleSearch(event) {
          const query = event.target.value.trim().toLowerCase();
          const items = this.querySelectorAll('[data-faq-item]');
          const categories = this.querySelectorAll('[data-faq-category]');
          let visibleCount = 0;

          items.forEach((item) => {
            const question = item.dataset.faqQuestion || '';
            const answer = item.dataset.faqAnswer || '';
            const matches = !query || question.includes(query) || answer.includes(query);

            item.hidden = !matches;
            if (matches) visibleCount += 1;
          });

          categories.forEach((category) => {
            const visibleItems = category.querySelectorAll('[data-faq-item]:not([hidden])');
            category.hidden = visibleItems.length === 0;

            const categoryId = category.id;
            const navItem = this.querySelector(`[data-faq-nav-item] a[href="#${categoryId}"]`)?.closest('[data-faq-nav-item]');
            if (navItem) navItem.hidden = category.hidden;
          });

          if (this.noResults) {
            this.noResults.hidden = visibleCount > 0 || !query;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["interactive-flyer-flipbook"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('interactive-flyer-flipbook')) {
    customElements.define(
      'interactive-flyer-flipbook',
      class InteractiveFlyerFlipbook extends HTMLElement {
        connectedCallback() {
          this.activeMarker = null;
          this.currentIndex = 0;
          this.touchStartX = 0;
          this.touchDeltaX = 0;
          this.zoom = 1;
          this.minZoom = 1;
          this.maxZoom = 2;
          this.zoomStep = 0.25;

          this.onMarkerClick = this.onMarkerClick.bind(this);
          this.onQuickViewClick = this.onQuickViewClick.bind(this);
          this.onCloseClick = this.onCloseClick.bind(this);
          this.onDocumentClick = this.onDocumentClick.bind(this);
          this.onKeyDown = this.onKeyDown.bind(this);
          this.onResize = this.onResize.bind(this);
          this.onPrevClick = this.onPrevClick.bind(this);
          this.onNextClick = this.onNextClick.bind(this);
          this.onTouchStart = this.onTouchStart.bind(this);
          this.onTouchEnd = this.onTouchEnd.bind(this);
          this.onZoomIn = this.onZoomIn.bind(this);
          this.onZoomOut = this.onZoomOut.bind(this);
          this.onResetZoom = this.onResetZoom.bind(this);
          this.onPrint = this.onPrint.bind(this);
          this.onToggleGrid = this.onToggleGrid.bind(this);
          this.onCloseGrid = this.onCloseGrid.bind(this);
          this.onToggleMore = this.onToggleMore.bind(this);
          this.onFullscreen = this.onFullscreen.bind(this);
          this.onGridSelect = this.onGridSelect.bind(this);

          this.activeDay = Number(this.dataset.activeDay || 2);
          this.hasTeaser = this.dataset.hasTeaser === 'true';
          this.viewer = this.querySelector('[data-flyer-viewer]');
          this.teaserMedia = this.querySelector('[data-flyer-media="teaser"]');
          this.toolbar = this.querySelector('[data-flyer-toolbar]');
          this.pages = Array.from(this.querySelectorAll('[data-flyer-page]'));
          this.prevButtons = Array.from(this.querySelectorAll('[data-flyer-prev]'));
          this.nextButtons = Array.from(this.querySelectorAll('[data-flyer-next]'));
          this.pageCurrentEl = this.querySelector('[data-flyer-page-current]');
          this.stage = this.querySelector('[data-flyer-stage]');
          this.mediaNav = this.querySelector('[data-flyer-media-nav]');
          this.dots = Array.from(this.querySelectorAll('[data-flyer-dot]'));
          this.gridPanel = this.querySelector('[data-flyer-grid-panel]');
          this.gridList = this.querySelector('[data-flyer-grid-list]');
          this.gridButton = this.querySelector('[data-flyer-grid]');
          this.moreButton = this.querySelector('[data-flyer-more]');
          this.moreMenu = this.querySelector('[data-flyer-more-menu]');
          this.zoomInButton = this.querySelector('[data-flyer-zoom-in]');
          this.zoomOutButton = this.querySelector('[data-flyer-zoom-out]');

          this.syncFlyerMode();
          this.buildGrid();
          this.goTo(0, false);
          this.applyZoom();

          this.querySelectorAll('[data-flyer-marker]').forEach((marker) => {
            marker.addEventListener('click', this.onMarkerClick);
          });

          this.querySelectorAll('[data-flyer-quick-view]').forEach((button) => {
            button.addEventListener('click', this.onQuickViewClick);
          });

          this.querySelectorAll('[data-flyer-close]').forEach((button) => {
            button.addEventListener('click', this.onCloseClick);
          });

          this.prevButtons.forEach((button) => button.addEventListener('click', this.onPrevClick));
          this.nextButtons.forEach((button) => button.addEventListener('click', this.onNextClick));
          this.dots.forEach((dot) => {
            dot.addEventListener('click', (event) => {
              event.preventDefault();
              const index = Number(event.currentTarget.dataset.pageIndex || 0);
              this.goTo(index);
            });
          });
          if (this.zoomInButton) this.zoomInButton.addEventListener('click', this.onZoomIn);
          if (this.zoomOutButton) this.zoomOutButton.addEventListener('click', this.onZoomOut);
          if (this.gridButton) this.gridButton.addEventListener('click', this.onToggleGrid);
          if (this.moreButton) this.moreButton.addEventListener('click', this.onToggleMore);

          this.querySelectorAll('[data-flyer-print]').forEach((button) => {
            button.addEventListener('click', this.onPrint);
          });
          this.querySelectorAll('[data-flyer-reset-zoom]').forEach((button) => {
            button.addEventListener('click', this.onResetZoom);
          });
          this.querySelectorAll('[data-flyer-fullscreen]').forEach((button) => {
            button.addEventListener('click', this.onFullscreen);
          });
          this.querySelectorAll('[data-flyer-grid-close]').forEach((button) => {
            button.addEventListener('click', this.onCloseGrid);
          });

          if (this.stage) {
            this.stage.addEventListener('touchstart', this.onTouchStart, { passive: true });
            this.stage.addEventListener('touchend', this.onTouchEnd, { passive: true });
          }

          document.addEventListener('click', this.onDocumentClick);
          document.addEventListener('keydown', this.onKeyDown);
          window.addEventListener('resize', this.onResize);
        }

        disconnectedCallback() {
          document.removeEventListener('click', this.onDocumentClick);
          document.removeEventListener('keydown', this.onKeyDown);
          window.removeEventListener('resize', this.onResize);
        }

        syncFlyerMode() {
          if (!this.hasTeaser || !this.teaserMedia) return;

          const isActiveDay = new Date().getDay() === this.activeDay;

          if (this.viewer) this.viewer.hidden = !isActiveDay;
          if (this.toolbar) this.toolbar.hidden = !isActiveDay;
          if (this.mediaNav) this.mediaNav.hidden = !isActiveDay;
          this.teaserMedia.hidden = isActiveDay;

          if (!isActiveDay) {
            this.closeAll();
            this.closeGrid();
            this.closeMore();
          }
        }

        buildGrid() {
          if (!this.gridList) return;

          this.gridList.innerHTML = '';

          this.pages.forEach((page, index) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'interactive-flyer-flipbook__grid-item';
            button.dataset.pageIndex = String(index);
            button.setAttribute('aria-label', `Go to page ${index + 1}`);

            const thumbSrc = page.dataset.thumbSrc;
            if (thumbSrc) {
              const img = document.createElement('img');
              img.src = thumbSrc;
              img.alt = page.dataset.pageLabel || `Page ${index + 1}`;
              img.loading = 'lazy';
              img.className = 'interactive-flyer-flipbook__grid-image';
              button.appendChild(img);
            } else {
              const placeholder = document.createElement('span');
              placeholder.className = 'interactive-flyer-flipbook__grid-placeholder';
              placeholder.textContent = String(index + 1);
              button.appendChild(placeholder);
            }

            const label = document.createElement('span');
            label.className = 'interactive-flyer-flipbook__grid-label';
            label.textContent = `${index + 1}`;
            button.appendChild(label);

            button.addEventListener('click', this.onGridSelect);
            this.gridList.appendChild(button);
          });
        }

        goTo(index, animate = true) {
          if (!this.pages.length) return;

          const nextIndex = Math.max(0, Math.min(index, this.pages.length - 1));
          this.currentIndex = nextIndex;

          this.pages.forEach((page, i) => {
            const isActive = i === nextIndex;
            page.hidden = !isActive;
            page.classList.toggle('is-active', isActive);
            if (animate && isActive) {
              page.classList.remove('is-entering');
              void page.offsetWidth;
              page.classList.add('is-entering');
            }
          });

          if (this.pageCurrentEl) {
            this.pageCurrentEl.textContent = String(nextIndex + 1);
          }

          this.prevButtons.forEach((button) => {
            button.disabled = nextIndex === 0;
          });
          this.nextButtons.forEach((button) => {
            button.disabled = nextIndex >= this.pages.length - 1;
          });

          this.dots.forEach((dot, i) => {
            if (i === nextIndex) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });

          this.querySelectorAll('.interactive-flyer-flipbook__grid-item').forEach((item, i) => {
            item.classList.toggle('is-active', i === nextIndex);
          });

          this.closeAll();
        }

        applyZoom() {
          this.style.setProperty('--flyer-zoom', String(this.zoom));
          if (this.stage) {
            this.stage.classList.toggle('is-zoomed', this.zoom > 1);
          }
          if (this.zoomInButton) this.zoomInButton.disabled = this.zoom >= this.maxZoom;
          if (this.zoomOutButton) this.zoomOutButton.disabled = this.zoom <= this.minZoom;
        }

        onZoomIn(event) {
          event.preventDefault();
          this.zoom = Math.min(this.maxZoom, Math.round((this.zoom + this.zoomStep) * 100) / 100);
          this.applyZoom();
          this.closeMore();
        }

        onZoomOut(event) {
          event.preventDefault();
          this.zoom = Math.max(this.minZoom, Math.round((this.zoom - this.zoomStep) * 100) / 100);
          this.applyZoom();
          this.closeMore();
        }

        onResetZoom(event) {
          event.preventDefault();
          this.zoom = 1;
          this.applyZoom();
          this.closeMore();
        }

        onPrint(event) {
          event.preventDefault();
          this.closeMore();

          const page = this.pages[this.currentIndex];
          if (!page) return;

          const image =
            page.querySelector('.interactive-flyer__image--desktop:not([hidden])') ||
            page.querySelector('.interactive-flyer__image:not(.interactive-flyer__image--placeholder)') ||
            page.querySelector('img, svg');

          const printWindow = window.open('', '_blank', 'noopener,noreferrer,width=900,height=1200');
          if (!printWindow) return;

          const src = image && image.tagName === 'IMG' ? image.currentSrc || image.src : '';
          const title = page.dataset.pageLabel || `Flyer page ${this.currentIndex + 1}`;

          printWindow.document.write(`<!doctype html><html><head><title>${title}</title>
            <style>
              html, body { margin: 0; padding: 0; background: #fff; }
              img, svg { display: block; width: 100%; height: auto; max-width: 100%; }
              @page { margin: 0; }
            </style>
          </head><body></body></html>`);
          printWindow.document.close();

          if (src) {
            const img = printWindow.document.createElement('img');
            img.src = src;
            img.alt = title;
            img.onload = () => {
              printWindow.focus();
              printWindow.print();
            };
            printWindow.document.body.appendChild(img);
          } else if (image) {
            printWindow.document.body.appendChild(image.cloneNode(true));
            printWindow.focus();
            printWindow.print();
          }
        }

        onToggleGrid(event) {
          event.preventDefault();
          event.stopPropagation();
          this.closeMore();
          if (!this.gridPanel) return;

          if (this.gridPanel.hidden) {
            this.gridPanel.hidden = false;
            if (this.gridButton) this.gridButton.setAttribute('aria-expanded', 'true');
            document.documentElement.classList.add('interactive-flyer-grid-open');
          } else {
            this.closeGrid();
          }
        }

        onCloseGrid(event) {
          if (event) {
            event.preventDefault();
            event.stopPropagation();
          }
          this.closeGrid();
        }

        closeGrid() {
          if (!this.gridPanel) return;
          this.gridPanel.hidden = true;
          if (this.gridButton) this.gridButton.setAttribute('aria-expanded', 'false');
          document.documentElement.classList.remove('interactive-flyer-grid-open');
        }

        onGridSelect(event) {
          event.preventDefault();
          const button = event.currentTarget;
          const index = Number(button.dataset.pageIndex || 0);
          this.goTo(index);
          this.closeGrid();
        }

        onToggleMore(event) {
          event.preventDefault();
          event.stopPropagation();
          if (!this.moreMenu) return;

          const willOpen = this.moreMenu.hidden;
          this.closeMore();
          if (willOpen) {
            this.moreMenu.hidden = false;
            if (this.moreButton) this.moreButton.setAttribute('aria-expanded', 'true');
          }
        }

        closeMore() {
          if (!this.moreMenu) return;
          this.moreMenu.hidden = true;
          if (this.moreButton) this.moreButton.setAttribute('aria-expanded', 'false');
        }

        onFullscreen(event) {
          event.preventDefault();
          this.closeMore();

          const target = this.viewer || this;
          if (!document.fullscreenElement) {
            if (target.requestFullscreen) target.requestFullscreen();
          } else if (document.exitFullscreen) {
            document.exitFullscreen();
          }
        }

        onPrevClick(event) {
          event.preventDefault();
          this.goTo(this.currentIndex - 1);
        }

        onNextClick(event) {
          event.preventDefault();
          this.goTo(this.currentIndex + 1);
        }

        onTouchStart(event) {
          if (this.zoom > 1) return;
          if (!event.changedTouches || !event.changedTouches[0]) return;
          this.touchStartX = event.changedTouches[0].clientX;
          this.touchDeltaX = 0;
        }

        onTouchEnd(event) {
          if (this.zoom > 1) return;
          if (!event.changedTouches || !event.changedTouches[0]) return;
          this.touchDeltaX = event.changedTouches[0].clientX - this.touchStartX;
          if (Math.abs(this.touchDeltaX) < 50) return;
          if (this.touchDeltaX > 0) this.goTo(this.currentIndex - 1);
          else this.goTo(this.currentIndex + 1);
        }

        isMobile() {
          return window.matchMedia('(max-width: 740px)').matches;
        }

        getPanel(marker) {
          const id = this.isMobile() ? marker.dataset.sheetId : marker.dataset.tooltipId;
          return id ? document.getElementById(id) : null;
        }

        onMarkerClick(event) {
          event.preventDefault();
          event.stopPropagation();

          if (this.viewer && this.viewer.hidden) return;

          const marker = event.currentTarget;
          if (this.activeMarker === marker) {
            this.closeAll();
            return;
          }

          this.openMarker(marker);
        }

        openMarker(marker) {
          this.closeAll();
          this.closeMore();

          const panel = this.getPanel(marker);
          if (!panel) return;

          marker.setAttribute('aria-expanded', 'true');
          marker.classList.add('is-active');
          panel.hidden = false;
          panel.classList.add('is-open');
          this.activeMarker = marker;

          if (this.isMobile()) {
            document.documentElement.classList.add('interactive-flyer-sheet-open');
          }
        }

        closeAll() {
          this.querySelectorAll('[data-flyer-marker].is-active').forEach((marker) => {
            marker.classList.remove('is-active');
            marker.setAttribute('aria-expanded', 'false');
          });

          this.querySelectorAll('[data-flyer-tooltip].is-open, [data-flyer-sheet].is-open').forEach((panel) => {
            panel.classList.remove('is-open');
            panel.hidden = true;
          });

          document.documentElement.classList.remove('interactive-flyer-sheet-open');
          this.activeMarker = null;
        }

        onCloseClick(event) {
          event.preventDefault();
          event.stopPropagation();
          this.closeAll();
        }

        onQuickViewClick(event) {
          event.preventDefault();
          event.stopPropagation();

          const button = event.currentTarget;
          const drawerId = button.getAttribute('aria-controls');
          const drawer = drawerId ? document.getElementById(drawerId) : null;

          this.closeAll();

          if (drawer) drawer.open = true;
        }

        onDocumentClick(event) {
          if (this.moreMenu && !this.moreMenu.hidden && !event.target.closest('.interactive-flyer-flipbook__more')) {
            this.closeMore();
          }

          if (!this.activeMarker) return;
          if (this.contains(event.target)) {
            if (event.target.closest('[data-flyer-tooltip], [data-flyer-marker], [data-flyer-sheet] .interactive-flyer__sheet-panel')) {
              return;
            }
          }
          this.closeAll();
        }

        onKeyDown(event) {
          if (event.key === 'Escape') {
            if (this.gridPanel && !this.gridPanel.hidden) {
              this.closeGrid();
              return;
            }
            if (this.moreMenu && !this.moreMenu.hidden) {
              this.closeMore();
              return;
            }
            if (this.activeMarker) {
              this.closeAll();
              return;
            }
          }

          if (this.viewer && this.viewer.hidden) return;
          if (event.target && ['INPUT', 'TEXTAREA', 'SELECT'].includes(event.target.tagName)) return;

          if (event.key === 'ArrowLeft') this.goTo(this.currentIndex - 1);
          if (event.key === 'ArrowRight') this.goTo(this.currentIndex + 1);
          if (event.key === '+' || event.key === '=') this.onZoomIn(event);
          if (event.key === '-' || event.key === '_') this.onZoomOut(event);
        }

        onResize() {
          if (this.activeMarker) this.closeAll();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["interactive-flyer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('interactive-flyer')) {
    customElements.define(
      'interactive-flyer',
      class InteractiveFlyer extends HTMLElement {
        connectedCallback() {
          this.activeMarker = null;
          this.onMarkerClick = this.onMarkerClick.bind(this);
          this.onQuickViewClick = this.onQuickViewClick.bind(this);
          this.onCloseClick = this.onCloseClick.bind(this);
          this.onDocumentClick = this.onDocumentClick.bind(this);
          this.onKeyDown = this.onKeyDown.bind(this);
          this.onResize = this.onResize.bind(this);

          this.activeDay = Number(this.dataset.activeDay || 2);
          this.hasTeaser = this.dataset.hasTeaser === 'true';
          this.activeMedia = this.querySelector('[data-flyer-media="active"]');
          this.teaserMedia = this.querySelector('[data-flyer-media="teaser"]');
          this.hotspots = this.querySelector('[data-flyer-hotspots]');

          this.syncFlyerMode();

          this.querySelectorAll('[data-flyer-marker]').forEach((marker) => {
            marker.addEventListener('click', this.onMarkerClick);
          });

          this.querySelectorAll('[data-flyer-quick-view]').forEach((button) => {
            button.addEventListener('click', this.onQuickViewClick);
          });

          this.querySelectorAll('[data-flyer-close]').forEach((button) => {
            button.addEventListener('click', this.onCloseClick);
          });

          document.addEventListener('click', this.onDocumentClick);
          document.addEventListener('keydown', this.onKeyDown);
          window.addEventListener('resize', this.onResize);
        }

        disconnectedCallback() {
          document.removeEventListener('click', this.onDocumentClick);
          document.removeEventListener('keydown', this.onKeyDown);
          window.removeEventListener('resize', this.onResize);
        }

        /**
         * Match weekly-deal-countdown: event day uses visitor local weekday.
         * Teaser shows on all other days when teaser images are configured.
         */
        syncFlyerMode() {
          if (!this.hasTeaser || !this.teaserMedia) return;

          const isActiveDay = new Date().getDay() === this.activeDay;

          if (this.activeMedia) {
            this.activeMedia.hidden = !isActiveDay;
          }

          this.teaserMedia.hidden = isActiveDay;

          if (this.hotspots) {
            this.hotspots.hidden = !isActiveDay;
          }

          if (!isActiveDay) {
            this.closeAll();
          }
        }

        isMobile() {
          return window.matchMedia('(max-width: 740px)').matches;
        }

        getPanel(marker) {
          const id = this.isMobile() ? marker.dataset.sheetId : marker.dataset.tooltipId;
          return id ? document.getElementById(id) : null;
        }

        onMarkerClick(event) {
          event.preventDefault();
          event.stopPropagation();

          if (this.hotspots && this.hotspots.hidden) return;

          const marker = event.currentTarget;
          if (this.activeMarker === marker) {
            this.closeAll();
            return;
          }

          this.openMarker(marker);
        }

        openMarker(marker) {
          this.closeAll();

          const panel = this.getPanel(marker);
          if (!panel) return;

          marker.setAttribute('aria-expanded', 'true');
          marker.classList.add('is-active');
          panel.hidden = false;
          panel.classList.add('is-open');
          this.activeMarker = marker;

          if (this.isMobile()) {
            document.documentElement.classList.add('interactive-flyer-sheet-open');
          }
        }

        closeAll() {
          this.querySelectorAll('[data-flyer-marker].is-active').forEach((marker) => {
            marker.classList.remove('is-active');
            marker.setAttribute('aria-expanded', 'false');
          });

          this.querySelectorAll('[data-flyer-tooltip].is-open, [data-flyer-sheet].is-open').forEach((panel) => {
            panel.classList.remove('is-open');
            panel.hidden = true;
          });

          document.documentElement.classList.remove('interactive-flyer-sheet-open');
          this.activeMarker = null;
        }

        onCloseClick(event) {
          event.preventDefault();
          event.stopPropagation();
          this.closeAll();
        }

        onQuickViewClick(event) {
          event.preventDefault();
          event.stopPropagation();

          const button = event.currentTarget;
          const drawerId = button.getAttribute('aria-controls');
          const drawer = drawerId ? document.getElementById(drawerId) : null;

          this.closeAll();

          if (drawer) {
            drawer.open = true;
          }
        }

        onDocumentClick(event) {
          if (!this.activeMarker) return;
          if (this.contains(event.target)) {
            const sheet = event.target.closest('[data-flyer-sheet]');
            if (sheet && event.target.matches('[data-flyer-close]')) return;
            if (event.target.closest('[data-flyer-tooltip], [data-flyer-marker], [data-flyer-sheet] .interactive-flyer__sheet-panel')) {
              return;
            }
          }
          this.closeAll();
        }

        onKeyDown(event) {
          if (event.key === 'Escape' && this.activeMarker) {
            this.closeAll();
          }
        }

        onResize() {
          if (this.activeMarker) {
            this.closeAll();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-spotlight"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.pdp-spotlight').forEach((root) => {
      root.querySelectorAll('[data-action="open-store-picker"]').forEach((button) => {
        button.addEventListener('click', () => {
          window.dispatchEvent(new CustomEvent('age-gate:open-stores'));
        });
      });

      root.querySelectorAll('[data-action="switch-to-delivery"]').forEach((button) => {
        button.addEventListener('click', () => {
          window.dispatchEvent(new CustomEvent('product:switch-to-delivery'));
        });
      });

      root.querySelectorAll('[data-action="scroll-store-info"]').forEach((button) => {
        button.addEventListener('click', () => {
          const target =
            document.querySelector('.shopify-section--store-info') ||
            document.querySelector('[id*="store_info"]');

          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });

      root.querySelectorAll('[data-description-collapse]').forEach((button) => {
        button.addEventListener('click', () => {
          const details = button.closest('.pdp-spotlight__description-toggle');
          if (details) {
            details.open = false;
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
